module.exports = __webpack_public_path__ + "e2c00dad60af0e18bb204d8f23bd6b79.png";